import { tabletMax, tabletMin, mobileLargeMin } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const PRODUCT_TABS_HEIGHT = 54;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.theme.background};
  z-index: 10;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 26px;
  height: ${PRODUCT_TABS_HEIGHT}px;
  overflow: hidden;

  @media print {
    display: none;
  }
`;

const TextStyle = css`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.textDark};
  white-space: nowrap;
  transition: color 300ms linear;

  @media (${tabletMax}) {
    font-size: 14px;
  }
`;

export const Text = styled.p`
  ${TextStyle}
  display: none;

  @media (${mobileLargeMin}) {
    display: block;
  }
`;

export const MobileText = styled.p`
  ${TextStyle}
  display: block;

  @media (${mobileLargeMin}) {
    display: none;
  }
`;

export const LinkButton = styled(Link)<{ $active?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border-right: 1px solid ${({ theme }) => theme.backgroundLight};
  color: ${({ theme }) => theme.textDark};
  background-color: ${({ theme }) => theme.white};
  transition:
    color 300ms linear,
    background-color 300ms linear;

  &:last-child {
    border-right: none;
  }

  ${({ theme, $active }) =>
    $active &&
    css`
      background-color: ${theme.primary};
      p {
        font-weight: bold;
        color: ${theme.white};
      }
    `}

  &:hover {
    p {
      color: ${({ theme, $active }) => ($active ? theme.white : theme.primary)};
    }
  }

  @media (${tabletMin}) {
    width: 210px;
  }

  @media (max-width: 360px) {
    padding: 0 8px;
  }
`;
